import React, { useState } from 'react';
import './thumbnail.scss';

export default function Thumbnail({ product, handleClick, brand }) {
  const [image, setImage] = useState(product.thumbnail);

  let productTitle = product.title;
  if (product.product_groups) {
    const title = product.product_groups.filter(g => g.category === 1)[0].title.toLowerCase();
    const brandLower = brand.toLowerCase();
    if (title.includes(brandLower)) {
      productTitle = title.replace(brandLower, '').trim();
    } else {
      productTitle = title;
    }
  }

  const handleImage404Error = () => {
    setImage(null);
  };

  return (
    <div
      key={product.name}
      className="thumbnail"
    >
      <div
        className="innerThumbnail"
        onClick={e => handleClick(e, product)}
        role="button"
        tabIndex="0"
      >
        {product.thumbnail &&
        <picture>
          <source media="(min-width: 768px)" srcSet={image || ''} />
          <source srcSet={image || ''} />
          <img
            onError={() => handleImage404Error()}
            src={image || ''}
            alt={productTitle}
          />
        </picture>
        }
        <div className="name">{productTitle}</div>
      </div>
    </div>
  );
}
